import gql from 'graphql-tag';

export default gql`
query listFA_CustomerInvoiceSummaryReportID($languageId: Int){
    fakturaAssist{
    listFA_CustomerInvoiceSummaryReportID(languageId: $languageId){
		id
        form
        name
        formId
        formIdDefault
    }
    
  }
}`;
